<template>
  <div>
    <a-row>
      <a-col :span="7">
        <span class="app-key-value__row">
          <span class="app-key-value__key beneficiary-item-label">
            {{ 'beneficiary-item.lbl-applicant-id' | globalize }}:
          </span>
          <span
            class="app-key-value__value beneficiary-item-value"
            :title="item.applicantId">
            {{ item.applicantId }}
          </span>
        </span>
      </a-col>
      <a-col :span="4">
        <span class="app-key-value__row">
          <span class="app-key-value__key beneficiary-item-label">
            {{ 'beneficiary-item.lbl-type' | globalize }}:
          </span>
          <span
            class="app-key-value__value value"
            :title="item.type">
            {{ item.type }}
          </span>
        </span>
      </a-col>
      <a-col :span="6">
        <span class="app-key-value__row">
          <span class="app-key-value__key beneficiary-item-label">
            {{ 'beneficiary-item.lbl-email' | globalize }}:
          </span>
          <span
            class="app-key-value__value beneficiary-item-value"
            :title="item.email">
            {{ item.email }}
          </span>
        </span>
      </a-col>
      <a-col :span="7">
        <span class="app-key-value__row">
          <span class="app-key-value__key beneficiary-item-label">
            {{ 'beneficiary-item.lbl-full-name' | globalize }}:
          </span>
          <span
            class="app-key-value__value beneficiary-item-value"
            :title="fullName">
            <value-with-default-na :value="fullName" />
          </span>
        </span>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="7">
        <span class="app-key-value__row">
          <span class="app-key-value__key beneficiary-item-label">
            {{ 'beneficiary-item.lbl-country' | globalize }}:
          </span>
          <span
            class="app-key-value__value beneficiary-item-value"
            :title="item.country">
            <country :code="item.country" />
          </span>
        </span>
      </a-col>
      <a-col :span="4">
        <span class="app-key-value__row">
          <span class="app-key-value__key beneficiary-item-label">
            {{ 'beneficiary-item.lbl-dob' | globalize }}:
          </span>
          <span
            class="app-key-value__value beneficiary-item-value"
            :title="item.dob">
            <value-with-default-na :value="item.dob" />
          </span>
        </span>
      </a-col>
      <a-col :span="6">
        <span class="app-key-value__row">
          <span class="app-key-value__key beneficiary-item-label">
            {{ 'beneficiary-item.lbl-phone' | globalize }}:
          </span>
          <span
            class="app-key-value__value beneficiary-item-value"
            :title="item.phone">
            <value-with-default-na :value="item.phone" />
          </span>
        </span>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <span class="app-key-value__key beneficiary-item-label">
          {{ 'beneficiary-item.lbl-sm-status' | globalize }}:
        </span>
        <span
          class="app-key-value__value beneficiary-item-value"
          :title="item.reviewStatus">
          <value-with-default-na :value="item.reviewStatus" />
        </span>
      </a-col>
      <a-col :span="12">
        <span class="app-key-value__key beneficiary-item-label">
          {{ 'beneficiary-item.lbl-review-result' | globalize }}:
        </span>
        <span
          class="app-key-value__value beneficiary-item-value"
          :title="item.reviewResult">
          <two-colored-status :value="item.reviewResult" />
        </span>
      </a-col>
    </a-row>
    <a-row>
      <a-collapse
        active-key="beneficiary-item.lbl-docs"
        expand-icon-position="right"
      >
        <a-collapse-panel
          :force-render="true"
          key="beneficiary-item.lbl-docs"
          :header="'beneficiary-item.lbl-docs' | globalize">
          <beneficiary-docs :data="docs" />
        </a-collapse-panel>
      </a-collapse>
    </a-row>
  </div>
</template>

<script>
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import ARow from 'ant-design-vue/lib/row'
import ACol from 'ant-design-vue/lib/col'
import BeneficiaryDocs from './beneficiary-docs'
import Country from '../country/Country'
import ValueWithDefaultNa from '../value-with-default-na'
import TwoColoredStatus from '../two-colored-status'

export default {
  name: 'beneficiary-item',
  components: {
    ARow,
    ACol,
    Country,
    'value-with-default-na': ValueWithDefaultNa,
    BeneficiaryDocs,
    TwoColoredStatus,
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    fullName () {
      const { firstName, middleName, lastName } = this.item
      const fullName = firstName && lastName
        ? `${firstName} ${middleName} ${lastName}`
        : 'n/a'
      return fullName
    },
    docs () {
      const dataSource = this.item.docs && Array.isArray(this.item.docs) ? this.item.docs : []

      return dataSource
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/grid/style/index.css';
  @import '~ant-design-vue/lib/collapse/style/index.css';

  .beneficiary-item-label {
    text-align: right;
  }

  .beneficiary-item-value {
    text-align: left;
  }
</style>
